var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-62",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20816",
    "data-name": "Path 20816",
    d: "M12,24A12,12,0,1,1,24,12,12.035,12.035,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.029,10.029,0,0,0,12,2Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20817",
    "data-name": "Path 20817",
    d: "M418.8,393a1.389,1.389,0,0,1-1-.5c-.5-.7-.1-1.7,1-4.4.2-.4.4-.9.6-1.3a1.071,1.071,0,0,1-1.4-.1.967.967,0,0,1,0-1.4,5.112,5.112,0,0,1,2.8-1.3,1.389,1.389,0,0,1,1,.5c.5.7.1,1.7-1,4.4-.2.4-.4.9-.6,1.3a1.071,1.071,0,0,1,1.4.1.967.967,0,0,1,0,1.4A5.112,5.112,0,0,1,418.8,393Z",
    transform: "translate(-407.798 -375)",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20818",
    "data-name": "Path 20818",
    d: "M513.5,214.833m-1.5,0a1.5,1.5,0,1,0,1.5-1.5A1.5,1.5,0,0,0,512,214.833Z",
    transform: "translate(-500 -208.333)",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20819",
    "data-name": "Path 20819",
    d: "M492.667,196a2,2,0,1,1,2-2A2.006,2.006,0,0,1,492.667,196Zm0-3a1,1,0,1,0,1,1A.945.945,0,0,0,492.667,193Z",
    transform: "translate(-479.167 -187.5)",
    fill: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.b5bc61e91f35e37aaee285074aedffed.svg";
export { ForwardRef as ReactComponent };